import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import CallIcon from '@mui/icons-material/Call';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ProfileStepper from '../../components/stepper/ProfileStepper'
import StudentSidebar from '../../components/sidebar/StudentSidebar'
import StudentNavbar from '../../components/navbar/StudentNavbar'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Paper, Typography } from '@mui/material'
import StudentProfileAccordion from '../../components/accordion/StudentProfileAccordion'
import PersonalStudentInfo from '../../components/form/PersonalStudentInfo'
import ContactStudentInfo from '../../components/form/ContactStudentInfo'
import AddressStudentDetails from '../../components/form/AddressStudentDetails'
import PassportStudentDetails from '../../components/form/PassportStudentDetails'
import TargetCountryDetails from '../../components/form/TargetCountryDetails'
import TestStudentDetails from '../../components/form/TestStudentDetails'
import LinearProgressStudent from '../../components/linearProgress/LinearProgressStudent'
import CreatePopup from '../../components/createPopup/CreatePopup';
import ExpertCallForm from '../../components/scheduleExpertCall.jsx/ExpertCallForm';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PersonalDetailsForm from '../../views/student/profile/PersonalDetailsForm';
import ContactDetailsForm from '../../views/student/profile/ContactDetailsForm';
import TestDetails from '../../views/student/profile/TestDetails';
import MainCard from '../../newTestPreo/components/MainCard';
import { BorderAllRounded } from '@mui/icons-material';
import RequestCallBack from '../../newTestPrepDesign/pages/RequestCallBack';
import { Close } from '@mui/icons-material';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  

function StudentMyProfile() {
    //const { studentId } = useSelector((state) => state.user)
    const enquiryId = localStorage.getItem('enquiryId');
    const enquiryPersonalDetailId = localStorage.getItem("enquiryPersonalDetailId");
    const [openDialog1, setOpenDialog1] = useState(false)
    const [studentData, setStudentData] = useState({})
    

    const handleOpenDialog1 = () => {
        setOpenDialog1(true)
    }

    const handleCloseDialog1 = () => {
        setOpenDialog1(false)
    }

    useEffect(() => {
      fetch(`${API_ENDPOINT}lmenquirycrm/${enquiryPersonalDetailId}`)
      .then(res => res.json())
      .then(student => {
        setStudentData(student)
      })
  }, []);
      console.log('this is my data:', studentData);
      
     

  return (
    <>
       <MainCard>
        <Box>
        
        <Typography variant='h3' align='center'>Welcome to Your SIEC Test Masters Student Portal</Typography>
        <Box m={2}/>
      <ProfileStepper />
      
      </Box>

      <Box mt={2} display='flex' justifyContent='space-between'>
       {/* <Box width='40%'>
      <LinearProgressStudent />
  </Box> */}
      <Box >
      <Stack direction="row" spacing={2} >
      <Button variant="contained" color='secondary' style={{ borderRadius: '20px' }} startIcon={<CallIcon />} onClick={handleOpenDialog1}>
        Book an expert call
      </Button>
      <Link to='/allclasses'>
      <Button variant="contained" color='secondary' style={{ borderRadius: '20px' }} startIcon={<VideoCameraFrontIcon />}>
        Book a demo
      </Button>
      </Link>
      <Link to='/allclasses'>
      <Button variant="contained" color='secondary' style={{ borderRadius: '20px' }} endIcon={<OndemandVideoIcon />}>
        Enroll to a class
      </Button>
      </Link>
    </Stack>
      </Box>
      </Box>
     
      <Box mt={2}>
        <Paper elevation={6}>
        <StudentProfileAccordion
            title='Personal Details'
            component={<><PersonalDetailsForm studentData={studentData}/></> }
         />
         <StudentProfileAccordion 
            title='Contact Details'
            component={<ContactDetailsForm  studentData={studentData}/>}
            defaultExpanded
         />
        {/*  <StudentProfileAccordion 
            title='Test Details'
            component={<TestDetails studentData={studentData} />}
         />
        <StudentProfileAccordion 
            title='Test Details'
            component={<TestStudentDetails />}
         />
          <StudentProfileAccordion 
            title='Score Details'
            component={<TargetCountryDetails />}
/>*/}
         </Paper>
      </Box>
     {/*} <CreatePopup
        open={openDialog1}
        title='Schedule Expert Call' 
        onClose={handleCloseDialog1}
        component={<ExpertCallForm />}
/>*/}
      </MainCard>

      <Dialog
      open={openDialog1}
      onClose={handleCloseDialog1}
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: '10px', // Add border radius
        border: '2px solid #4CAF50', // Add green border
      }}
    >
         <DialogTitle variant='h4'>
        Request Call Back
        <IconButton aria-label="close" onClick={handleCloseDialog1} sx={{ position: 'absolute', top: 0, right: 0 }}>
          <Close />
        </IconButton>
      </DialogTitle>
        <DialogContent>
          <RequestCallBack onClose={handleCloseDialog1} />
        </DialogContent>
      </Dialog>
      </>
  )
}

export default StudentMyProfile